// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var TailwindMerge = require("tailwind-merge");
var TailwindVariants = require("../../../../v5/bindings/TailwindVariants.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var TailwindVariants$1 = require("tailwind-variants");
var ReactAriaComponents = require("react-aria-components");

var radio = TailwindVariants$1.tv({
      extend: TailwindVariants.Utils.focusRing,
      base: "size-[14px] rounded-full border-zinc-300 border bg-white transition-all text-white",
      variants: {
        isSelected: {
          true: "group-pressed:border-gray-500 text-tan-blue-500"
        },
        isInvalid: {
          true: "border-red-700 group-pressed:border-red-800"
        },
        isDisabled: {
          true: "border-gray-200"
        }
      }
    });

var groupItem = TailwindVariants$1.tv({
      base: "p-4 flex flex-col items-start cursor-pointer relative border-x",
      variants: {
        isFirst: {
          true: "rounded-t-md border-t"
        },
        isLast: {
          true: "rounded-b-md"
        },
        isSelected: {
          true: "bg-[#F0F8FF] border border-tan-blue-500/35"
        },
        isDisabled: {
          true: "opacity-70 cursor-not-allowed"
        }
      }
    });

var Styles = {
  radio: radio,
  groupItem: groupItem
};

function Form__Radio$CircleIcon(props) {
  return JsxRuntime.jsx("svg", {
              children: JsxRuntime.jsx("circle", {
                    cx: "6",
                    cy: "6",
                    fill: "currentColor",
                    r: "4"
                  }),
              height: "14",
              width: "14",
              viewBox: "0 0 14 14"
            });
}

var CircleIcon = {
  make: Form__Radio$CircleIcon
};

function Form__Radio$RadioGroup(props) {
  var __className = props.className;
  var className = __className !== undefined ? __className : "flex flex-col gap-2";
  return JsxRuntime.jsx(ReactAriaComponents.RadioGroup, {
              children: props.children,
              className: className,
              name: props.name,
              value: props.value,
              onChange: props.onChange
            });
}

var RadioGroup = {
  make: Form__Radio$RadioGroup
};

function Form__Radio$Radio(props) {
  var __renderWrapper = props.renderWrapper;
  var __disabled = props.disabled;
  var __circleClassName = props.circleClassName;
  var __labelClassName = props.labelClassName;
  var label = props.label;
  var labelClassName = __labelClassName !== undefined ? __labelClassName : "";
  var circleClassName = __circleClassName !== undefined ? __circleClassName : "";
  var disabled = __disabled !== undefined ? __disabled : false;
  var renderWrapper = __renderWrapper !== undefined ? __renderWrapper : (function (param, content) {
        return content;
      });
  return JsxRuntime.jsx(ReactAriaComponents.Radio, {
              value: props.value,
              children: (function (renderProps) {
                  return renderWrapper(renderProps, JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsx(Form__Radio$CircleIcon, {}),
                                          className: TailwindMerge.twMerge([
                                                radio(renderProps),
                                                circleClassName
                                              ])
                                        }),
                                    label !== undefined ? JsxRuntime.jsx(ReactAriaComponents.Label, {
                                            children: label,
                                            className: TailwindMerge.twMerge([
                                                  "cursor-pointer",
                                                  labelClassName
                                                ])
                                          }) : null
                                  ],
                                  className: "flex items-center gap-2"
                                }));
                }),
              isDisabled: disabled
            });
}

var Radio = {
  make: Form__Radio$Radio
};

function Form__Radio$RadioCardList$ItemsRenderer(props) {
  var toValue = props.toValue;
  var items = props.items;
  var state = React.useContext(ReactAriaComponents.RadioGroupStateContext);
  var value = state.selectedValue;
  var selectedValueIndex;
  selectedValueIndex = value === null ? -1 : items.findIndex(function (item) {
          return toValue(item.value) === value;
        });
  return items.filter(function (item) {
                return item.skip !== true;
              }).map(function (item, index) {
              var disabled = Core__Option.getOr(item.disabled, false);
              var isFirst = index === 0;
              var isLast = index === (items.length - 1 | 0);
              var circleClass = disabled ? "border-gray-200" : undefined;
              return JsxRuntime.jsx(Form__Radio$Radio, {
                          label: item.title,
                          labelClassName: "font-semibold",
                          value: toValue(item.value),
                          circleClassName: circleClass,
                          disabled: disabled,
                          renderWrapper: (function (renderProps, content) {
                              var isDirectlyAboveSelected = selectedValueIndex === (index - 1 | 0);
                              var isDirectlyBelowSelected = selectedValueIndex === (index + 1 | 0);
                              var selectedStatus = isDirectlyAboveSelected ? "DirectlyAbove" : (
                                  isDirectlyBelowSelected ? "DirectlyBelow" : "None"
                                );
                              var overlay = item.overlay;
                              var description = item.description;
                              return JsxRuntime.jsxs("div", {
                                          children: [
                                            content,
                                            JsxRuntime.jsx("div", {
                                                  children: JsxRuntime.jsxs("div", {
                                                        children: [
                                                          overlay !== undefined ? JsxRuntime.jsx("div", {
                                                                  children: overlay,
                                                                  className: "whitespace-nowrap bg-tan-gold-light text-white uppercase text-[10px] rounded-[3px] px-1.5 py-0.5 border border-tan-gold-light absolute top-4 right-4"
                                                                }) : null,
                                                          description !== undefined ? JsxRuntime.jsx("div", {
                                                                  children: description,
                                                                  className: TailwindMerge.twMerge([
                                                                        "mt-2 mr-6 text-zinc-700",
                                                                        disabled ? "text-zinc-500" : ""
                                                                      ])
                                                                }) : null
                                                        ],
                                                        className: "flex content-between"
                                                      }),
                                                  className: "w-full ml-[22px]"
                                                })
                                          ],
                                          className: TailwindMerge.twMerge([
                                                groupItem({
                                                      isFirst: isFirst,
                                                      isLast: isLast,
                                                      isSelected: renderProps.isSelected,
                                                      isDisabled: disabled
                                                    }),
                                                selectedStatus === "DirectlyBelow" ? "border-b-0" : (
                                                    selectedStatus === "None" ? "border-b" : "border-t-0 border-b"
                                                  )
                                              ])
                                        });
                            })
                        }, toValue(item.value));
            });
}

var ItemsRenderer = {
  make: Form__Radio$RadioCardList$ItemsRenderer
};

function Form__Radio$RadioCardList(props) {
  var onChange = props.onChange;
  var toValue = props.toValue;
  var items = props.items;
  return JsxRuntime.jsx(Form__Radio$RadioGroup, {
              children: JsxRuntime.jsx(Form__Radio$RadioCardList$ItemsRenderer, {
                    items: items,
                    toValue: toValue
                  }),
              name: props.name,
              value: toValue(props.selected),
              onChange: (function (v) {
                  var item = items.find(function (item) {
                        return toValue(item.value) === v;
                      });
                  if (item !== undefined) {
                    return onChange(item.value);
                  }
                  
                }),
              className: "flex flex-col gap-0 border-zinc-200 rounded-md overflow-hidden"
            });
}

var RadioCardList = {
  ItemsRenderer: ItemsRenderer,
  make: Form__Radio$RadioCardList
};

function Form__Radio$RadioList(props) {
  var __layout = props.layout;
  var onChange = props.onChange;
  var toValue = props.toValue;
  var items = props.items;
  var layout = __layout !== undefined ? __layout : "Vertical";
  var tmp;
  tmp = layout === "Vertical" ? "flex flex-col gap-3" : "flex flex-row gap-3";
  return JsxRuntime.jsx(Form__Radio$RadioGroup, {
              children: items.filter(function (item) {
                      return item.skip !== true;
                    }).map(function (item) {
                    var disabled = Core__Option.getOr(item.disabled, false);
                    var circleClass = disabled ? "border-gray-200" : undefined;
                    return JsxRuntime.jsx(Form__Radio$Radio, {
                                label: item.label,
                                value: toValue(item.value),
                                circleClassName: circleClass
                              }, toValue(item.value));
                  }),
              name: props.name,
              value: toValue(props.selected),
              onChange: (function (v) {
                  var item = items.find(function (item) {
                        return toValue(item.value) === v;
                      });
                  if (item !== undefined) {
                    return onChange(item.value);
                  }
                  
                }),
              className: tmp
            });
}

var RadioList = {
  make: Form__Radio$RadioList
};

exports.Styles = Styles;
exports.CircleIcon = CircleIcon;
exports.RadioGroup = RadioGroup;
exports.Radio = Radio;
exports.RadioCardList = RadioCardList;
exports.RadioList = RadioList;
/* radio Not a pure module */
